// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api/v1',
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

// Route Paths
export const ROUTES = {
  HOME: '/',
  MYDIABETES: '/my-diabetes',
  MEDICAL: '/medical',
  WHAT_IS_DIABETES: '/what-is-diabetes',
  LINKS: '/links',
  REGIONS: '/regions',
  // Content pages will be dynamic: /content/:slug
};

// Page Types
export const PAGE_TYPES = {
  HOME: 'home',
  SECTION: 'section',
  CONTENT: 'content',
  EXTERNAL: 'external',
} as const;

// Content Section Types
export const SECTION_TYPES = {
  WELCOME: 'welcome',
  QUICK_LINKS: 'quickLinks',
  MYDIABETES: 'myDiabetes',
  REGIONS: 'regions',
  SOCIAL: 'social',
} as const;

// Breakpoints (matching theme)
export const BREAKPOINTS = {
  MOBILE: 600,
  TABLET: 800,
  DESKTOP: 1000,
  WIDE: 1200,
};

// Icon Grid Configuration
export const ICON_CONFIG = {
  WIDTH: 160,
  HEIGHT: 202,
  GRID_GAP: 24,
  COLUMNS: {
    DESKTOP: 4,
    TABLET: 3,
    MOBILE: 2,
    SMALL_MOBILE: 1,
  },
};

// Hero Section Configuration
export const HERO_CONFIG = {
  HEIGHT: 500,
  LOGO_HEIGHT: 120,
};

// Cache Configuration
export const CACHE_CONFIG = {
  NAVIGATION_TTL: 24 * 60 * 60 * 1000, // 24 hours
  PAGE_TTL: 60 * 60 * 1000, // 1 hour
  ASSETS_TTL: 7 * 24 * 60 * 60 * 1000, // 7 days
};

// Error Messages
export const ERROR_MESSAGES = {
  PAGE_NOT_FOUND: 'Page not found',
  NETWORK_ERROR: 'Network error occurred',
  LOADING_ERROR: 'Error loading content',
  GENERIC_ERROR: 'An unexpected error occurred',
};

// Loading Messages
export const LOADING_MESSAGES = {
  PAGE: 'Loading page...',
  NAVIGATION: 'Loading navigation...',
  CONTENT: 'Loading content...',
};

// Accessibility
export const A11Y = {
  SKIP_LINK_TEXT: 'Skip to main content',
  MENU_TOGGLE_TEXT: 'Toggle navigation menu',
  LOADING_TEXT: 'Content is loading',
  ERROR_TEXT: 'An error occurred',
};

// Social Media
export const SOCIAL_MEDIA = {
  FACEBOOK_GROUP: 'https://www.facebook.com/groups/325847170871339/',
};

// External Links
export const EXTERNAL_LINKS = {
  WORDPRESS_COM: 'https://wordpress.com/?ref=footer_blog',
  DIABETES_LIVE: 'https://diabeteslive.co.nz'
};

// Asset Paths
export const ASSET_PATHS = {
  IMAGES: '/assets/images',
  ICONS: '/assets/images/icons',
  BACKGROUNDS: '/assets/images/backgrounds',
  LOGO: '/assets/images/logo',
  DOCUMENTS: '/assets/documents',
};

// Default Values
export const DEFAULTS = {
  PAGE_TITLE: 'Diabetes Live NZ',
  PAGE_DESCRIPTION: 'New Zealand Youth with Type 1 Diabetes - information and resources for young people with diabetes',
  AUTHOR: 'Kirsty Newton',
  AUTHOR_TITLE: 'Diabetes Nurse Specialist',
  LOCATION: 'Wellington',
};

export default {
  API_CONFIG,
  ROUTES,
  PAGE_TYPES,
  SECTION_TYPES,
  BREAKPOINTS,
  ICON_CONFIG,
  HERO_CONFIG,
  CACHE_CONFIG,
  ERROR_MESSAGES,
  LOADING_MESSAGES,
  A11Y,
  SOCIAL_MEDIA,
  EXTERNAL_LINKS,
  ASSET_PATHS,
  DEFAULTS,
};
